// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_cX","cityChooser__text":"c-j_cY","cityChooser__placeholder":"c-j_cZ","cityChooser__buttonIcon":"c-j_ea"};